import { theme } from 'antd';
import React from 'react';
import styled from 'styled-components';

const { useToken } = theme;

const ResponsiveContainerDiv = styled.div`
  max-width: ${(props) => props.screenXL}px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 0;
  margin: auto;
  @media (max-width: ${(props) => props.screenSMMax}px) {
    padding-left: 8px;
    padding-right: 8px;
  }
  max-width: ${(props) => props.size === 'small' && `${props.screenLG}px`};
  max-width: ${(props) => props.size === 'large' && `${props.screenXXL}px`};
  max-width: ${(props) => props.size === 'full' && `100%`};
`;
const ResponsiveContainer = ({ children, ...props }) => {
  const { token } = useToken();
  const { screenXL, screenSMMax, screenLG, screenXXL } = token;

  return (
    <ResponsiveContainerDiv
      {...{ screenXL, screenSMMax, screenLG, screenXXL }}
      {...props}
    >
      {children}
    </ResponsiveContainerDiv>
  );
};

export default ResponsiveContainer;
